/** Maps API / English probability & impact scale strings to riskOverview.levels.* i18n keys. */

export function translateRiskProbability(scale, t) {
    const s = String(scale || '').trim().toLowerCase();
    const compact = s.replace(/\s+/g, '');
    let key = null;
    if (compact === 'almostcertain' || s === 'almost certain') key = 'almostCertain';
    else if (['rare', 'unlikely', 'possible', 'likely'].includes(compact)) key = compact;
    return key ? t(`riskOverview.levels.probability.${key}`) : scale;
}

export function translateRiskImpact(impact, t) {
    const s = String(impact || '').trim().toLowerCase();
    let key = null;
    if (s === 'catastrophe' || s === 'catastrophic') key = 'catastrophic';
    else if (['insignificant', 'minor', 'moderate', 'major'].includes(s)) key = s;
    return key ? t(`riskOverview.levels.impact.${key}`) : impact;
}
